<template>
  <div class="mainContaner full_w" style="background-color: white;height: 49rem">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <van-tabs :sticky="true" :line-width="32" v-model="active" :isFixed="true" animated :swipeable="true" title-active-color="#EB84AB" @change="changeAction">
        <van-tab title="售后申请" >
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh(1)">
            <div class="full_w" v-if="!emptyList" style="min-height: 45rem">
              <div class="content_item" v-for="(saleItem,saleIndex) in saleList" :key="saleIndex">
                <div class="base_line"></div>
                <p class="black zt14 clear_style clear_both" style="border-bottom: 1px solid #eaeaea;"><span class="fl" style="padding: 0.5rem 0.9rem;">订单号：{{saleItem.orderId}}</span></p>
                <div class="cart_group_item" v-for="(item,index) in saleItem.productList" @key="index">
                  <div style="margin-bottom: 0.5rem">
                    <div  class="clear_both" style="padding: 0.1rem 0.1rem;">
                      <van-image class="full_w fl group_item_img" :src="item.imageUrl" fit="cover" />
                      <div class="fl group_item_name" >
                        <p class="zt14 clear_style grey" style="position: absolute;margin-left: 14.5rem">x{{item.returnNum}}</p>
                        <p class="zt14 clear_style black" style="height: 4rem">{{item.productName}}</p>
                        <div class="clear_both">
                          <span class="fl zt14" style="color: #EB84AB">¥{{item.price}}</span>
                          <span @click="goApply(item,saleItem)" class="fr zt12" style="color: #EB84AB;border: 1px solid #EB84AB;border-radius: 1rem;padding: 0.1rem 0.4rem;">售后申请</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <refresh style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: saleList.length,show:show}'></refresh>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="退换记录">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh(2)">
            <div class="full_w" v-if="!emptyList" style="min-height: 45rem">
              <div class="content_item" v-for="(saleItem,saleIndex) in saleList" :key="saleIndex" @click="goDetail(saleItem.returnId,saleItem.status)">
                <div class="base_line"></div>
                <p class="black zt14 clear_style clear_both" style="border-bottom: 1px solid #eaeaea;"><span class="fl" style="padding: 0.5rem 0.9rem;">订单号：{{saleItem.orderId}}</span><span class="fr themeColor" style="padding: 0.5rem 0.9rem;">{{getStatus(saleItem.status)}}</span></p>
                <div class="cart_group_item" v-for="(item,index) in saleItem.productList" @key="index">
                  <div style="margin-bottom: 0.5rem">
                    <div  class="clear_both" style="padding: 0.1rem 0.1rem;">
                      <van-image class="full_w fl group_item_img" :src="item.imageUrl" fit="cover" />
                      <div class="fl group_item_name" >
                        <p class="zt14 clear_style grey" style="position: absolute;margin-left: 14.5rem">x{{item.num}}</p>
                        <p class="zt14 clear_style black" style="height: 4rem">{{item.productName}}</p>
                        <div class="clear_both">
                          <span class="fl zt14" style="color: #EB84AB">¥{{item.price}}</span>
                          <span v-if="saleItem.status == '2'" class="fr zt12" style="color: #EB84AB;border: 1px solid #EB84AB;border-radius: 1rem;padding: 0.1rem 0.4rem;">去寄货</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <refresh style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadChangeMore" :lastPage='{total: !allLoaded, empty: saleList.length,show:show}'></refresh>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
      <div class="cart_content" v-if="emptyList">
        <p class="tc grey zt16" style="padding: 2rem 0">没有售后记录</p>
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getAfterSaleList,getAfterSaleChangeList } from '@/router/api';
  import { setStore,getStore } from '@/utils/mUtil';
  import {Image,Button,Tab, Tabs } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'promoList',
    data() {
      return {
        active:0,
        token:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        showLoading:true,
        viewIndex:0,
        viewSize:20,
        emptyList:false,
        saleList:[],
        show: true,
        allLoaded: false,
        isLoading:false,
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      footerView,
      loading,
      refresh
    },
    methods:{
      async initData() {
        console.log(getStore('active'))
        if(getStore('active')==0){
          this.getAfterSaleList();
          this.active = 0
        }else if(getStore('active')==1){
          this.getAfterSaleChangeList();
          this.active = 1
        }else{
          this.getAfterSaleList();
          this.active = 0
        }

      },
      getAfterSaleList() {
        var param = {externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName}
        console.log(param)
        getAfterSaleList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
          .then(res => {
            console.log("getAfterSaleList")
            console.log(res)
            if (res.saleList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            if (res.saleList.length < this.viewSize) {
              this.allLoaded = true
            } else {
              this.allLoaded = false
            }
            this.saleList = res.saleList
            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getAfterSaleChangeList() {
        getAfterSaleChangeList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
          .then(res => {
            console.log("getAfterSaleChangeList")
            console.log(res)
            if (res.changeList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            if (res.changeList.length < this.viewSize) {
              this.allLoaded = true
            } else {
              this.allLoaded = false
            }
            this.saleList = res.changeList
            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },

      getPromoType(type) {
        var typeName = '';
        switch (type) {
          case 'gift':
            typeName = '礼品券'
            break;
          case 'discount':
            typeName = '折扣券'
            break;
          case 'deduct':
            typeName = '满减券'
            break;
          case 'special':
            typeName = '特价券'
            break;
          default:
            break
        }
        return typeName
      },
      getPromoValue(code) {
        var promoValue = '';
        switch (code.type) {
          case 'gift':
            promoValue = '赠品'
            break;
          case 'discount':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              if ((parseInt(code.value, 10) === code.value)==true) {
                promoValue = code.value + '.0'
              } else {
                promoValue = code.value
              }
            }
            break;
          case 'deduct':
            promoValue = code.value
            break;
          case 'special':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              promoValue = code.value
            }
            break;
          default:
            break
        }
        return promoValue
      },
      getPromoDate(item) {
        var msg = ""
        if (item.fromDate == null && item.thruDate == null) {
          msg = "不限制时间使用"
        }
        if (item.fromDate == null && item.thruDate != null) {
          msg = "截止到" + this.formatDate(item.thruDate) + "失效"
        }
        if (item.fromDate != null && item.thruDate == null) {
          msg = this.formatDate(item.fromDate) + "后开始使用"
        }
        if (item.fromDate != null && item.thruDate != null) {
          msg = this.formatDate(item.fromDate) + "-" + this.formatDate(item.thruDate)
        }
        return msg
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
      formatDate(value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return y + '.' + MM + '.' + d
        }else{
          return ''
        }
      },
      changeAction(name,title) {
        setStore('active',this.active)
        this.resetParam();
        switch (title) {
          case '售后申请':
            this.getAfterSaleList();
            break;
          case '退换记录':
            this.getAfterSaleChangeList();
            break;
          default:
            break
        }
      },
      resetParam(){
        this.viewIndex = 0;
        this.viewSize = 20;
        this.allLoaded=false;
        this.emptyList = false;
        this.saleList = [];
      },
      onRefresh() {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      clickAction(item) {
        this.$router.push({name:'giveawayList',query:{productPromoId:item.productPromoId,productPromoRuleId:item.productPromoRuleId}})
      },
      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          getAfterSaleList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
            .then(res => {
              console.log("getAfterSaleList")
              console.log(res)
              this.show = true
              if (res.saleList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }
              var oldSaleList = this.saleList
              var newSaleList = oldSaleList.concat(res.saleList)
              this.saleList = newSaleList
              this.viewIndex = res.viewIndex;
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      loadChangeMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          getAfterSaleChangeList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize,productStoreId: storeName})
            .then(res => {
              console.log("getAfterSaleChangeList")
              console.log(res)
              this.show = true
              if (res.saleList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }
              var oldSaleList = this.saleList
              var newSaleList = oldSaleList.concat(res.saleList)
              this.saleList = newSaleList
              this.viewIndex = res.viewIndex;
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
            })
            .catch(err => {
              console.log(err);
            });
        }
      },

      getStatus(status) {
        var text = ''
        switch (status) {
          case '0':
            text = '已提交'
            break;
          case '1':
            text = '待审核'
            break;
          case '2':
            text = '已审核'
            break;
          case '3':
            text = '待退款'
            break;
          case '4':
            text = '已退款'
            break;
          default:
            break;
        }
        return text;
      },

      goApply(item,saleItem) {
        setStore('active',this.active)
        this.$router.push({name:'afterType',query:{onlyRefund:item.onlyRefund,isReturns:item.isReturns,imageUrl:item.imageUrl,quantity:item.returnNum,price:item.price,productName:item.productName,orderId:saleItem.orderId,productId:item.productId,orderItemSeqId:item.orderItemSeqId}})
      },

      //跳转至详情
      goDetail:function (returnId,status) {
        setStore('active',this.active)
        if(status==2){
          this.$router.push({name:'afterLogistics',query:{returnId:returnId}})
        }else{
          this.$router.push({name:'afterStatus',query:{returnId:returnId}})
        }
      },
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    },
  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-top: 2.5rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding: 0.5rem 0.9rem;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 15.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 4rem;width: 100%;position: fixed;bottom: 0;background-color: transparent;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0rem 0 0rem 0;border-radius: 0.2rem;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 20rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  .base_line {
    height: 0.5rem;
    background-color: #f5f5f5;
  }

  .coupon_item {
    height: 7rem;
    padding: 0.25rem 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/after/afterList.vue